import { useEffect, useMemo } from 'preact/hooks';
import { ApiClient } from '../api/client.js';
import { BitmapCache, loadImageBitmap } from '../player/bitmap-cache.js';
import { PlayerController } from '../player/controller.js';
import { startClock } from '../state/store.js';
import { Controls } from './controls.js';
import { StatusBar } from './status-bar.js';
import { Timeline } from './timeline.js';
import { Toolbar } from './toolbar.js';
import { Viewer } from './viewer.js';

export const App = () => {
  const player = useMemo(() => new PlayerController(new ApiClient(), new BitmapCache(loadImageBitmap)), []);

  useEffect(() => {
    void player.start();
    const stopClock = startClock();
    return () => {
      player.stop();
      stopClock();
    };
  }, [ player ]);

  return (
    <div class="app">
      <Toolbar player={player} />
      <Viewer player={player} />
      <div class="app__bottom">
        <Timeline player={player} />
        <Controls player={player} />
      </div>
      <StatusBar />
    </div>
  );
};
